import {Link} from "react-router-dom";

const PokemonBox = (props) => {
    return(
        <Link to={`/pokedex/`+ props.pokemon.name} >
            <div className="pokemon-cont">
                    <img
                        src = {props.pokemon.img}
                        alt = {props.pokemon.name}
                    />
                <p>{props.pokemon.name}</p>
            </div>
        </Link>
    )
}

export default PokemonBox